import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Sidebar from '../components/Sidebar';
import { PageContainer, ContentContainer, Header } from '../components/ContentContainer';

const PomSceneEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const scene = params.get('scene');

  return (
    <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <Header>POM scene editor</Header>
      </ContentContainer>
    </PageContainer>
  );
};

export default PomSceneEditPage;


